import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_145: FaireProductEntity = {
  token: "legacy_prod_abbott-145",
  type: "product",
  name: "Candy Jar with Lid-8 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3906e92d2b8c521b1edf51667d9e33ba3211c228e83b98bd65b927009a926f2b.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
